
import { pageHeroImages } from '../../../utils/images';

export default function PromiseSection() {
  return (
    <section
      className="relative py-20 bg-cover bg-center bg-no-repeat pb-28"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url('${pageHeroImages.sustainabilityPromise}')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          <h2 className="text-5xl lg:text-6xl font-light text-white leading-tight">
            Our Promise
          </h2>
          <p className="text-xl text-gray-200 leading-relaxed font-light">
            By integrating sustainability, ethics, and innovation, Musheng ensures that every product we deliver is not only of the highest quality but also makes a positive contribution to people and the planet.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="text-center space-y-3">
              <h3 className="text-xl font-medium text-white">For the Planet</h3>
              <p className="text-gray-300 font-light">
                Minimizing our environmental footprint through sustainable practices and responsible resource management.
              </p>
            </div>
            <div className="text-center space-y-3">
              <h3 className="text-xl font-medium text-white">For People</h3>
              <p className="text-gray-300 font-light">
                Creating positive impact in communities through fair labor practices and ethical partnerships.
              </p>
            </div>
            <div className="text-center space-y-3">
              <h3 className="text-xl font-medium text-white">For Innovation</h3>
              <p className="text-gray-300 font-light">
                Leading the industry with cutting-edge sustainable technologies and forward-thinking solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
